import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

if (process.env.REACT_APP_DEBUG_ENV) {
}

export function mapApiResponse(resp) {
  const data = resp?.data || {};
  return {
    error: Boolean(data.error),
    message: data.message || "",
    status: Number(data.status || resp?.status || 500),
    body: Object.prototype.hasOwnProperty.call(data, "body") ? data.body : null,
  };
}

apiClient.interceptors.response.use(
  (response) => {
    if (response?.config?.responseType === "blob") return response;
    const mapped = mapApiResponse(response);
    if (mapped.error) {
      const apiError = new Error(
        mapped.message || "An error occurred while processing the request.",
      );
      apiError.status = mapped.status;
      apiError.body = mapped.body;
      throw apiError;
    }
    return mapped;
  },
  (error) => {
    const backendMessage = error?.response?.data?.message;
    const rawPayload =
      typeof error?.response?.data === "string" ? error.response.data : "";
    const fallbackMessage =
      error?.message || "An error occurred while processing the request.";
    const status = error?.response?.status || 500;
    let message = backendMessage || fallbackMessage;

    if (
      rawPayload.includes("Cannot GET /") ||
      message.includes("Cannot GET /") ||
      message.includes("Network Error")
    ) {
      message = "Could not connect to the authentication service.";
    }

    if (error?.response?.status === 401) {
      message =
        backendMessage ||
        "Invalid or expired session. Please sign in again.";
    }

    const apiError = new Error(message);
    apiError.status = status;
    apiError.body = error?.response?.data?.body || null;
    throw apiError;
  },
);

export async function apiRequest(path, options = {}) {
  const isFormData =
    typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = { ...(options.headers || {}) };
  if (isFormData) {
    headers["Content-Type"] = "multipart/form-data";
  } else if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  if (process.env.REACT_APP_DEBUG_ENV) {
  }

  const response = await apiClient({
    url: path,
    method: options.method || "GET",
    data: options.body,
    headers,
    ...(options.responseType ? { responseType: options.responseType } : {}),
  });
  return response;
}

export default apiClient;
